import { InjectionToken, Provider, Type } from '@angular/core';

import { OnAppInit, runOnAppInit } from '@frontend/vanilla/core';

export const ON_BINGO_APP_INIT = new InjectionToken<OnAppInit>('ON_BINGO_APP_INIT');

export function runOnBingoAppInit<T extends OnAppInit>(type: Type<T>): Provider[] {
    return [
        runOnAppInit(type),
        {
            provide: ON_BINGO_APP_INIT,
            multi: true,
            useExisting: type,
        },
    ];
}
